export default "__VITE_ASSET__DsuUEze3__"